<template>
    <div
        class="DateFilterDropdown"
        @click.stop=""
    >
        <div
            :class="{
                'DateFilterDropdown__options-container': true,
                'DateFilterDropdown__options-container--modal': isModal
            }"
        >
            <div class="DateFilterDropdown__preselected-date">
                <label
                    v-for="opt in options"
                    :key="opt.label"
                    class="FilterOption"
                    @click="select(opt.value)"
                >
                    <input
                        :checked="isSelected(opt.value)"
                        type="radio"
                        class="FilterOption__radio"
                        @click.prevent=""
                    >
                    <span
                        class="FilterOption__text"
                    >{{ opt.label }}</span>
                </label>
            </div>
            <div
                v-if="open !== ''"
                :class="{
                    'DateFilterDropdown__calendar-container': !isModal,
                    'DateFilterDropdown__calendar-container--modal': isModal
                }"
            >
                <DatePicker
                    :value="currentRange"
                    :mode="dateSelector.mode"
                    :columns="dateSelector.columns"
                    :rows="dateSelector.rows"
                    is-inline
                    @input="setSelected"
                />
            </div>
        </div>
        <div class="DateFilterDropdown__buttons-container">
            <RPButton
                :disabled="submitDisabled"
                size="lg"
                label="Submit"
                class="DateFilterDropdown__button"
                @click="submit"
            />
            <RPButton
                size="lg"
                class="DateFilterDropdown__button"
                type="tertiary"
                label="Cancel"
                @click="$emit('close')"
            />
        </div>
    </div>
</template>
<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import RPButton from 'components/Basic/Buttons/RPButton.vue';

export default {
    name: 'DateFilterDropdown',
    components: {
        DatePicker,
        RPButton
    },
    props: {
        currentDates: {
            type: Object,
            required: true
        },
        options: {
            type: Array,
            required: true,
        },
        isModal: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            selected: {},
            open: ''
        };
    },
    computed: {
        currentRange(){
            if(!isEmpty(this.currentDates)){
                return {
                    start: new Date(this.currentDates.date_from),
                    end: new Date(this.currentDates.date_to)
                };
            }
            return new Date();
        },
        dateSelector(){
            if(open === 'open-single') {
                return {
                    mode: 'single',
                    columns: 1,
                    rows: 1,
                };
            }
            return {
                mode: 'range',
                columns: this.isModal ? 1 : 2,
                rows: this.isModal ? 2: 1
            };
        },
        submitDisabled(){
            return isEqual(this.currentDates, this.selected);
        }
    },
    mounted(){
        this.selected = this.currentDates;
    },
    methods: {
        isSelected(val){
            return isEqual(this.selected, val)
              || this.open === val;
        },
        select(val){
            if(typeof val === 'string') {
                this.open = val;
            } else {
                this.selected = val;
                this.open = '';
            }
        },
        setSelected(s){
            this.selected =
              (this.open === 'open-single')
                  ? {
                      date_from: moment(s).format('YYYY-MM-DD'),
                      date_to: moment(s).format('YYYY-MM-DD'),
                  }
                  : {
                      date_from: moment(s.start).format('YYYY-MM-DD'),
                      date_to: moment(s.end).format('YYYY-MM-DD'),
                  };
        },
        submit() {
            this.$emit('select', this.selected);
        }
    },
};
</script>
<style lang="scss">
    .DateFilterDropdown {
        width: min-content;
        margin: 1rem 0.5rem 0.5rem 1rem;

        &__options-container {
            margin-bottom: 1rem;
            display: flex;
            &--modal {
                flex-wrap: wrap;
            }
            
        }
        &__calendar-container {
            margin-left: 3rem;
            &--modal {
                margin: 1rem 0.5rem 0 0;

            }
        }
        &__buttons-container {
            display: flex;
            flex-wrap: wrap;
        }
        &__button {
            width: 11rem;
            margin-bottom: 0.5rem;
            margin-right: 0.5rem;
        }
    }
    .FilterOption {
        cursor: pointer;
        color: $text-grey;
        display: flex;
        margin-right: 0.25rem;
        align-items: center;
        &:not(:last-child){ margin-bottom: 0.5rem; }
        &__text {
            white-space: nowrap;
        }
        &__radio {
            cursor: pointer;
            margin: -0.25rem 0.25rem 0 0;
            font-size: 1rem;
        }
    }
</style>
